import React from "react";
import Filler from "../../components/Filler";
import HomeInfo from "./components/HomeInfo";

const Home: React.FC = () => {
  return (
    <main className="flex-grow flex flex-col md:flex-row items-stretch">
      <HomeInfo />
      <Filler />
    </main>
  );
};

export default Home;
